const en = {
  common: {
    aiPet: 'AI Pet',
    allTime: 'All Time',
    analyze: 'Analyze',
    backHome: 'Back home',
    cancel: 'Cancel',
    close: 'Close',
    copied: 'Copied',
    copy: 'Copy',
    copyFailed: 'Copy failed',
    delete: 'Delete',
    detail: 'Details',
    downloadProject: 'Download project files',
    downloadSource: 'Download source',
    downloadTool: 'Download tool',
    english: 'English',
    favorite: 'Save',
    followed: 'Following',
    followUpdates: 'Follow updates',
    github: 'GitHub',
    githubAnalysis: 'GitHub Project Analysis',
    loading: 'Loading',
    login: 'Log in',
    logout: 'Log out',
    manageAdmin: 'Admin',
    myAccount: 'My account',
    myFavorites: 'My favorites',
    myGithub: 'My GitHub',
    nextPage: 'Next',
    openGithub: 'View GitHub',
    openSourceRepo: 'Open source repo',
    previousPage: 'Previous',
    register: 'Sign up',
    retry: 'Retry',
    search: 'Search',
    share: 'Share',
    simplifiedChinese: 'Chinese',
    sourceCode: 'Source repo',
    unlabeled: 'Unlabeled',
    unknown: 'Unknown',
    userCenter: 'Profile',
    viewDetail: 'View details',
    zh: 'Chinese',
  },
  header: {
    languageSwitchToEnglish: 'English',
    languageSwitchToChinese: 'Chinese',
  },
  nav: {
    aria: 'Main navigation',
    brand: 'QingTu AI',
    brandSub: 'College growth and career planning platform',
    closeMenu: 'Close navigation menu',
    developer: 'Developer',
    githubAnalysis: 'GitHub Analysis',
    benefits: 'Benefits',
    more: 'More',
    dailyRanking: 'Daily Ranking',
    allTimeRanking: 'All-time Ranking',
    todayRecommendations: 'Today Picks',
    openTools: 'Open Tools',
    developerTools: 'Developer Tools',
    home: 'Home',
    language: 'Language',
    mobileAria: 'Mobile navigation',
    openMenu: 'Open navigation menu',
    navHome: 'Home',
    navDashboard: 'Growth Center',
    navLearning: 'Learning Paths',
    navRoadmap: 'Project Practice',
    navGrowth: 'My Growth',
    navExplore: 'Explore Paths',
    navProjectsResume: 'Outcomes',
    navAiPartner: 'AI Partner',
    navMore: 'More',
    ordinary: 'For Everyone',
    resumeAnalyzer: 'Resume',
    interview: 'Interview Prep',
    student: 'Student Growth',
  },
  moreMenu: {
    title: 'More Features',
    competitions: 'Competitions',
    competitionsDesc: 'Find competitions by major and goal.',
    certificates: 'Certificates',
    certificatesDesc: 'Plan certificates at the right roadmap stage.',
    interview: 'Interview',
    interviewDesc: 'Prepare introductions, project stories, and interview questions by role.',
    resume: 'Resume',
    resumeDesc: 'Review your resume and generate copy-ready improvements.',
    aiTools: 'AI Tools',
    aiToolsDesc: 'Browse AI tools for learning, projects, and career work.',
    dailyRanking: 'Daily Ranking',
    dailyRankingDesc: 'View today ranked projects.',
    allTimeRanking: 'All-time Ranking',
    allTimeRankingDesc: 'View long-term rankings.',    todayPicks: "Today's picks",
    todayPicksDesc: 'Browse today recommended tools and projects.',
    githubAnalysis: 'GitHub Analysis',
    githubAnalysisDesc: 'Analyze project strengths, resume value, and interview talking points.',
    vip: 'VIP Benefits',
    vipDesc: 'Review member benefits and limits.',
    support: 'Support',
    supportDesc: 'Submit activation, refund, and bug tickets.',
    profile: 'Profile',
    profileDesc: 'View account and saved items.',
    loginProfileDesc: 'Log in to enter your profile.',
    admin: 'Admin Console',
    adminDesc: 'Visible to admins only.',
  },
  growthCenter: {
    taskFallbackTitle: 'Growth task',
    eventFallbackTitle: 'Growth record',
    project: 'Project',
    resume: 'Resume',
    interview: 'Interview',
    learning: 'Learning',
    currentTarget: 'Current target',
    fallbackLearningTask: 'Map 3 core abilities for {{target}}',
    fallbackProjectTask: 'Choose one portfolio project for your resume',
    fallbackResumeTask: 'Add one resume experience related to your goal',
    emptyEyebrow: 'AI Student Growth Platform',
    emptyTitle: 'Create a career plan first, then I will generate your learning route.',
    emptyDesc: 'Career planning becomes the shared goal for Growth Center, daily tasks, project recommendations, competitions, certificates, and training assistant.',
    aboutThreeMinutes: 'About 3 min',
    beginnerFirst: 'Beginner first',    dailyTasks: "Today's tasks",
    generateChangePlan: 'Generate my change plan',
    myProjectResults: 'My project results',
    heroTitle: 'Know the next step every day and see the long-term path.',
    heroDesc: 'Career planning, daily tasks, project recommendations, competitions, certificates, and training assistant will keep moving around your current goal.',
    adjustGoal: 'Adjust growth goal',
    loadFailedTitle: 'Loading failed. Refresh or submit feedback',
    retry: 'Retry',
    submitFeedback: 'Submit feedback',
    todayTasks: 'Today growth tasks',
    loadingTodayTasks: 'Loading today tasks...',
    remainingTasks: '{{count}} tasks left today',
    estimatedXp: 'Estimated {{minutes}} minutes, {{xp}} XP.',
    dailyDesc: 'Move from confusion to portfolio, resume, and interview step by step.',
    progressLabel: 'Completion progress {{progress}}%',
    startTodayPlan: 'Start today plan',
    closedLoop: 'Growth data loop',
    weeklyReport: 'This week growth report',
    closedLoopFallback: 'The system will suggest next steps from learning, practice, project, and career actions.',
    learningTime: 'Learning time',
    minutes: '{{count}} min',
    learningTimeDesc: 'From learning nodes, practice, and project progress',
    completedTasks: 'Completed tasks',
    completedTasksDesc: 'Learning and practice completions are counted automatically',
    abilityGrowth: 'Ability growth',
    abilityGrowthDesc: 'Based on learning completion and practice scores',
    projectProgress: 'Project progress',
    projectProgressDesc: 'From project task status and submitted outcomes',
    todayAdvice: 'Today advice',
    noRecentActivity: 'No recent activity yet. Finish one learning action first.',
    learningOverview: 'Learning overview',
    currentDirection: 'Current direction',    routeProgress: 'Route {{progress}}% complete ? Current stage {{stage}}',
    notStarted: 'Not started',
    practiceAndProject: 'Practice and project',
    projectLabel: 'Project: {{label}}',
    noActiveProject: 'No active project',
    nextSuggestion: 'Next suggestion',
    streakDays: '{{count}} day growth streak',
    nextSuggestionFallback: 'Finish the next learning node first, then complete 2 basic practices.',
    levelAria: 'Growth level and growth value',
    growthLevel: 'Growth level',
    growthLevelDesc: 'Keeps increasing after tasks and stages are completed',
    growthValue: 'Growth value',
    growthValueDesc: 'Tasks, routes, and timeline records all count',
    timelineCount: 'Timeline',
    timelineFallback: 'Key growth actions will be recorded after you save a plan',
    learningRoute: 'Learning route',
    stagesCompleted: '{{done}}/{{total}} stages completed',
    viewFullRoute: 'View full route',
    currentStage: 'Current stage',
    none: 'None',
    createPlanForRoute: 'Create a career plan first to generate your learning route.',
    nextStage: 'Next stage',
    finalStage: 'Final stage reached',
    finalStageDesc: 'After this stage, keep improving resume and interview expression.',
    stageOrder: 'Stage {{order}}',
    loading: 'Loading...',
    loadingLong: 'If it takes too long, refresh or submit feedback.',
    noTasksTitle: 'No tasks today yet',
    noTasksDesc: 'Generate your first growth plan in career planning.',
    goCareerPlanner: 'Go to career planning',
    markDone: 'Mark done',
    done: 'Done',
    updatedAt: 'Updated at: {{time}}',
    trainingActive: 'Training active',
    itemCount: '{{count}} items',
    trainingFallback: 'Training tasks are generated. Continue today tasks.',
    competitionPrep: 'Competition prep',
    competitionFallback: 'Added to growth plan. Continue generating today competition tasks.',
    certificatePrep: 'Certificate prep',
    certificateFallback: 'Added to growth plan. Continue generating today certificate tasks.',
    growthTimeline: 'Growth timeline',
    recentRecords: 'Recent records',
    timelineDesc: 'Plans, task completions, projects, and learning resources will be recorded here.',
    waitingFirstRecord: 'Waiting for first record',
    firstRecordTitle: 'Complete one career plan or daily task first',
    firstRecordDesc: 'Key growth actions will sync to the timeline for review.',
    trainingAssistant: 'AI Training Assistant',
    majorDirections: 'Major directions',
    competitionPlanning: 'Competition planning',
    certificatePlanning: 'Certificate planning',
    projectRecommendations: 'Project recommendations',
    resumeOptimization: 'Resume optimization',
    interviewPrep: 'Interview prep',
  },
  growthDaily: {
    eyebrow: 'My Growth',
    title: 'Today, focus on the next useful step',
    subtitle: 'Your goal, current stage, tasks, advice, and recent outcomes are gathered here so you can start without browsing every feature.',
    currentState: 'Current growth state',
    currentGoal: 'Current goal',
    currentStage: 'Current stage',
    stageProgress: 'Stage progress',
    progressValue: '{{progress}}%',
    existingPlanGoal: 'Existing growth plan',
    existingPlanStage: 'Continue current plan',
    noGoal: 'No goal yet',
    noStage: 'No stage yet',
    adjustGoal: 'Adjust goal',
    viewLearning: 'Learning route',
    todayTasks: "Today's tasks",
    pendingTasks: '{{count}} tasks left today',
    allDone: 'Today is clear',
    taskDesc: 'Keep only the tasks that move the current goal forward.',
    openToday: 'Open today',
    createFirstTask: 'Create today task first',
    taskFallback: 'Growth task',
    taskMeta: '{{minutes}} min · {{xp}} XP',
    markDone: 'Mark done',
    done: 'Done',
    noTaskTitle: 'No task for today yet',
    noTaskDesc: 'Start from direction exploration or ask the AI partner to create a next step.',
    findDirection: 'Explore direction',
    nextAdvice: 'Next advice',
    companionAdvice: 'AI partner observation',
    companionObservationPending: 'Partner observation: your goal is "{{goal}}", and {{count}} tasks are still open today. Move the smallest useful step first instead of browsing more tools.',
    companionObservationDone: 'Partner observation: you have moved "{{goal}}" forward today. A short review can turn the progress into visible evidence.',
    companionObservationNoGoal: 'Partner observation: there is no clear growth goal yet. Start with direction exploration so later tasks can follow a real target.',
    companionActionTask: 'Today, start with: {{task}}',
    nextFallbackTitle: 'Start with one small action',
    nextFallbackDesc: 'Choose a direction, finish one learning action, or package one outcome.',
    noTaskStatus: 'Waiting for tasks',
    doNext: 'Do this next',
    recentOutcomes: 'Recent outcomes',
    outcomeSummary: '{{projects}} projects · {{resumes}} resumes',
    outcomeDesc: 'Only the latest visible outcomes are shown here. Details stay in the outcome library.',
    viewAssets: 'View assets',
    projectOutcome: 'Project outcome',
    projectOutcomeDesc: 'Project evidence from your growth plan.',
    resumeOutcome: 'Resume asset',
    resumeOutcomeDesc: 'Resume analysis or optimization result.',
    resumeScore: 'Latest resume score: {{score}}',
    noOutcomeTitle: 'No visible outcome yet',
    noOutcomeDesc: 'Complete a project or resume action to make progress visible.',
    secondaryActions: 'Secondary growth actions',
    report: 'Report',
    reportDesc: 'Weekly report, ability analysis, and full growth review.',
    timeline: 'Timeline',
    timelineDesc: 'Review plans, task completions, projects, and learning records.',
    assets: 'Assets',
    assetsDesc: 'Projects, learning records, resume assets, and growth evidence.',
    competitions: 'Competitions',
    competitionsDesc: 'Move competition planning to a secondary page.',
    resume: 'Resume',
    resumeDesc: 'Keep resume optimization outside the first screen.',
    interview: 'Interview',
    interviewDesc: 'Use interview prep when entering career preparation.',
    loginTitle: 'Log in to see your growth state',
    loginDesc: 'After logging in, this page will show your current goal, today tasks, next advice, and recent outcomes.',
    startDiagnosis: 'Start growth diagnosis',
    previewTitle: 'What you will see after login',
    previewDesc: 'You can explore a direction before registering. Log in when you want to save your goal, tasks, and outcomes.',
    previewGoal: 'Current goal',
    previewGoalValue: 'What you want to reach next',
    previewStage: 'Current stage',
    previewStageValue: 'From exploration to outcomes',
    previewTask: "Today's task",
    previewTaskValue: 'The most useful step today',
    previewNext: 'Next advice',
    previewNextValue: 'A clear action based on your state',
    previewOutcome: 'Recent outcome',
    previewOutcomeValue: 'Projects, resume, and learning records',
    loading: 'Loading growth state...',
    loadFailed: 'Growth state failed to load.',
    loadFailedTitle: 'Growth state is unavailable',
    completeFailed: 'Task update failed. Please try again.',
    errorEyebrow: 'Growth Center',
    errorTitle: 'Growth Center could not load',
    errorDesc: 'The page met an error, but existing features are still available.',
    retry: 'Retry',
    timelineTitle: 'Growth timeline',
    timelinePageDesc: 'This page keeps the longer review history outside the daily first screen.',
    timelineLoginTitle: 'Log in to view your growth timeline',
    timelineLoginDesc: 'Plans, task completions, learning records, and projects will appear here after login.',
    timelineLoadFailed: 'Growth timeline failed to load.',
    backToGrowth: 'Back to My Growth',
    eventFallback: 'Growth record',
    eventFallbackDesc: 'A growth action was recorded.',
    waitingFirstRecord: 'Waiting for first record',
    firstRecordTitle: 'Complete one task first',
    firstRecordDesc: 'Your key growth actions will appear here for review.',
  },
  learningRoute: {
    eyebrow: 'Learning route',
    emptyTitle: 'Choose a direction before opening a learning route',
    emptyDesc: 'A learning route should serve your growth goal. Choose a direction or create a growth goal first, then continue into matching nodes and daily tasks.',
    chooseDirection: 'Explore direction',
    backGrowth: 'Back to My Growth',
    guideDirection: 'Direction first',
    guideDirectionDesc: 'Avoid forcing every student into one default job route.',
    guideTask: 'Then tasks',
    guideTaskDesc: 'The route should become today tasks, not only a long checklist.',
    guideSaved: 'Sync after saving',
    guideSavedDesc: 'After login, your goal, route, and tasks sync to My Growth.',
    guideSavedDescLoggedIn: 'Your goals, routes, and tasks sync back to My Growth.',
    optionalTitle: 'Existing routes are still available',
    optionalDesc: 'The Java backend route remains available as an optional route, not the default for every student.',
    viewJavaRoute: 'View Java backend route',
    loadingTitle: 'Loading learning route...',
    continueLearning: 'Continue learning',
    viewTodayTask: "View today's task",
    nodeProgress: '{{done}}/{{total}} nodes completed',
    loadFailedTitle: 'Route failed to load',
    loadFailedDesc: 'The learning route is temporarily unavailable, so a default route frame is shown.',
    overviewAria: 'Learning route overview',
    currentDirection: 'Current direction',
    targetRole: 'Target role',
    entryLevel: 'Entry level',
    estimatedDays: '{{difficulty}} · about {{days}} days',
    viewRouteDetail: 'View route details',
    todayTask: "Today's task",
    firstNodeTitle: 'Start from the first learning node',
    firstNodeDesc: 'Completed nodes will be recorded in My Growth.',
    startTodayTask: "Start today's task",
    currentStage: 'Current stage',
    waitingRouteData: 'Waiting for route data',
    routeDataFallback: 'If the API is temporarily unavailable, this page stays usable with a clear fallback.',
    viewTodayPlan: "View today's plan",
    stageListAria: 'Learning route stages',
    loadingStage: 'Loading route',
    loadingStageTitle: 'Preparing learning nodes',
    loadingStageDesc: 'Reading stages, resources, practices, and project entries.',
    emptyState: 'Empty state',
    noNodesTitle: 'No learning nodes yet',
    noNodesDesc: 'The route data is not ready. Try again later or return to My Growth to choose a direction.',
    stageLabel: 'Stage {{order}}',
    stageFallbackDesc: 'After this stage, continue with projects and practice.',
    daysValue: '{{days}} days',
    stageProgress: '{{progress}}% complete · {{done}}/{{total}} nodes',
    learningNode: 'Learning node',
    defaultDuration: '30 minutes',
    view: 'View',
    continue: 'Continue',
    start: 'Start',
    typeVideo: 'Video',
    typeDocument: 'Document',
    typePractice: 'Practice',
    typeProject: 'Project',
    typeReview: 'Review',
    typeLearning: 'Learning',
    nodeDone: 'Done',
    nodeNotStarted: 'Not started',
  },
  projectHub: {
    eyebrow: 'Outcome Library',
    title: 'Your student outcome assets',
    subtitle: 'Collect projects, proof, and resume materials here so every piece of work can explain what you can do.',
    loginTitle: 'Log in to view your outcome library',
    loginDesc: 'Projects, GitHub evidence, and resume materials gather here so your experience can become visible, resume-ready, and interview-ready outcomes.',
    previewStart: 'View improvement ideas',
    previewTitle: 'Outcome library preview',
    previewHeading: 'Start with three kinds of outcomes',
    previewDesc: 'The outcome library is not a tool list. It organizes learning, projects, and resume materials into evidence of ability.',
    previewProjectsTitle: 'My projects',
    previewProjectsDesc: 'Organize existing projects with context, role, process, and result.',
    previewImproveTitle: 'Project improvement ideas',
    previewImproveDesc: 'Find the next proof point that makes a project feel like a real outcome.',
    previewResumeTitle: 'Resume materials',
    previewResumeDesc: 'Turn project work into resume bullets and interview stories.',
    githubAsEnhancer: 'GitHub strengthens outcomes',
    githubAsEnhancerDesc: 'Repositories, commits, and README files support project credibility instead of becoming another standalone tool wall.',
    overview: 'Outcome overview',
    activeProjects: 'Active projects',
    completedProjects: 'Completed projects',
    resumeMaterials: 'Resume materials',
    existingProjects: 'Existing projects',
    visibleOutcomes: 'My outcomes',
    existingDesc: 'Keep only project outcomes that can explain your ability, process, and result.',
    viewMyProjects: 'My projects',
    noProjectsTitle: 'No project outcome yet',
    noProjectsDesc: 'Start from a small project plan, then turn the process into portfolio evidence.',
    untitledProject: 'Untitled project',
    projectFallbackDesc: 'Project evidence from your growth plan.',
    improvement: 'Improvement directions',
    improvementTitle: 'Next improvement suggestion',
    improvementDesc: 'Pick one action that makes your existing work easier to show in applications or interviews.',
    improveProjectTitle: 'Clarify one project story',
    improveProjectDesc: 'Explain the problem, your role, the process, and the result in a way others can understand.',
    startProjectDesc: 'Pick a suitable first project and turn it into a visible outcome.',
    githubEnhanceTitle: 'Strengthen proof with GitHub',
    githubEnhanceDesc: 'Use repository evidence to improve README, structure, technical expression, and resume value.',
    resumeEntry: 'Resume materials',
    resumeTitle: 'Prepare project materials for your resume',
    resumeDesc: 'Turn project background, actions, results, and evidence into resume-ready language.',
    resumeAsset: 'Resume asset',
    resumeAssetDesc: 'A resume material draft created from your project or analysis history.',
    noResumeAssetTitle: 'No resume material yet',
    noResumeAssetDesc: 'Prepare one project story first, then turn it into resume-ready language.',
    resumeScore: 'Latest resume score: {{score}}',
    prepareResume: 'Prepare resume materials',
    loading: 'Loading outcome library...',
    loadFailed: 'Outcome library failed to load.',
    loadFailedTitle: 'Unable to load outcome library',
  },
  exploreFlow: {
    majorInterest: 'Are you interested in your current major?',
    majorInterestInterested: 'Yes, prioritize careers related to my major',
    majorInterestUnsure: 'Unsure, assess it together with my abilities',
    majorInterestNotInterested: 'No, I want to explore another field',
    preferredField: 'What field are you genuinely interested in?',
    preferredFieldPlaceholder: 'For example: media, education, product design, AI, or finance',
    preferredFieldNote: 'AI will treat your major as transferable background while prioritizing this field.',
    eyebrow: 'Explore Direction',
    title: 'Find the growth direction that fits you',
    subtitle: 'By understanding your major, interests, goals, and learning habits, we help you decide the next stage.',
    backGrowth: 'My Growth',
    startExplore: 'Start exploring',
    flowAria: 'Direction exploration flow',
    selfSection: 'Know yourself',
    major: 'Major',
    majorPlaceholder: 'E.g. software engineering, accounting, media, nursing',
    grade: 'Grade',
    gradeFreshman: 'Freshman',
    gradeSophomore: 'Sophomore',
    gradeJunior: 'Junior',
    gradeSenior: 'Senior',
    gradeGraduate: 'Graduate student',
    interest: 'Interests',
    interestPlaceholder: 'E.g. data, writing, design, coding, stable work',
    personality: 'Personality tendency',
    personalityPlaceholder: 'E.g. steady, curious, social, independent, detail-oriented',
    learningHabit: 'Learning habit',
    level: 'Current level',
    levelBeginner: 'Just getting started',
    levelFoundation: 'Know the basics, need complete practice',
    levelIntermediate: 'Can complete projects independently',
    levelAdvanced: 'Experienced and ready to advance',
    currentSkills: 'Skills you already have',
    currentSkillsPlaceholder: 'E.g. React, Vue, TypeScript, performance optimization',
    currentSkillsNote: 'List skills you can actually use, separated by commas. Leave blank if needed.',
    dailyMinutes: 'Daily available time',
    dailyMinutesOption: '{{minutes}} minutes per day',
    dailyMinutesNote: 'AI will size daily tasks to this time.',
    habitProject: 'Project-driven',
    habitVideo: 'Video courses',
    habitReading: 'Reading and notes',
    habitPractice: 'Practice and exercises',
    habitDeadline: 'Deadlines and accountability',
    goal: 'Goal',
    goalInternship: 'Find an internship',
    goalJob: 'Prepare for jobs',
    goalGraduate: 'Graduate study',
    goalPortfolio: 'Build a portfolio',
    goalStable: 'Stable development',
    goalUnsure: 'Still unsure',
    mbti: 'MBTI, optional',
    mbtiPlaceholder: 'Optional, such as INFP or ENTJ',
    mbtiNote: 'Used only as a weak reference. It will not decide your direction.',
    aiExplore: 'AI exploration',
    emptyTitle: 'Start with your current situation',
    emptyDesc: 'Fill in your major, grade, interests, and goal first. Then generate a direction profile with fit reasons, gaps, and the next action.',
    formTitle: 'Fill in your current situation',
    formDesc: 'This step only collects the context needed for direction exploration. You can revise it before choosing a goal.',
    stepProgress: 'Step {{current}}/{{total}}',
    stepMajorTitle: 'Tell me your major and grade',
    stepMajorDesc: 'This helps estimate your current stage and which paths are realistic next.',
    stepInterestTitle: 'What are you interested in?',
    stepInterestDesc: 'Write courses, activities, topics, or problems you naturally pay attention to.',
    stepPersonalityTitle: 'Describe how you usually work',
    stepPersonalityDesc: 'Personality is only context. MBTI is optional and never decides the result.',
    stepHabitTitle: 'Choose your learning habit',
    stepHabitDesc: 'The plan should fit how you actually keep going, not an ideal schedule.',
    stepGoalTitle: 'Choose your current goal',
    stepGoalDesc: 'This decides whether the result should lean toward internship, portfolio, graduate study, or stability.',
    previousStep: 'Back',
    nextStepButton: 'Next',
    resultsTitle: 'Review your direction profile',
    resultsDesc: 'Choose one direction after reading the fit reason, current strengths, gaps, and next action.',
    editProfile: 'Edit information',
    needFormTitle: 'Fill in your information first',
    needFormDesc: 'Direction results are generated from your major, interests, learning habits, and goal.',
    generatePortrait: 'Generate direction profile',
    directionPortrait: 'Direction profile',
    directionPortraitDesc: 'These suggestions come from your current situation. Focus on fit, strengths, gaps, and the next action.',
    recommendedDirections: 'AI recommended roles',
    selectedDirection: 'Selected role',
    reviewSelectedDirection: 'Review and generate',
    closeFirstGap: 'Validate and close this gap with one small task: {{gap}}',
    auditBasics: 'Start with a basic capability audit',
    noGapData: 'Analyze further when generating the plan',
    companionDirectionText: 'You selected "{{direction}}" under "{{category}}". The plan will focus on your real skill gaps.',
    aiAnalyzingTitle: 'AI is analyzing suitable roles',
    aiAnalyzingDesc: 'Your major, interests, learning style, and goal are being compared with roles in the internal career library.',
    aiFallback: 'AI role analysis is temporarily unavailable. Career-library recommendations are shown instead.',
    selected: 'Selected',
    reviewDirection: 'Review',
    directionProfile: 'Direction profile',
    whyFit: 'Why it may fit',
    currentStrengths: 'Current strengths',
    currentGaps: 'Current gaps',
    nextAction: 'Next action',
    possibleOutcome: 'Possible outcome',
    companionObservation: 'AI partner observation',
    companionObservationText: 'Partner observation: you selected "{{direction}}". From your current state, {{strength}}',
    companionAdvice: 'Personalized advice',
    companionAdviceText: 'Do not chase a complete plan today. Start with one executable action: {{action}} Then turn it into: {{outcome}}',
    createGrowthGoal: 'Choose this role and generate AI plan',
    generatingGoal: 'AI is designing your plan...',
    createGoalFailed: 'Failed to generate the AI growth plan. Please try again.',
    initialStage: 'Direction validation',
    existingLogic: 'How this direction is generated',
    existingLogicDesc: 'We use your major, grade, interests, learning habits, and goal to suggest a practical next direction.',
    steps: {
      knowSelf: 'Know yourself',
      aiExplore: 'AI exploration',
      profile: 'Direction profile',
      choose: 'Choose direction',
      goal: 'Create goal',
      growth: 'Enter growth',
    },
    directions: {
      data: {
        title: 'Data analysis',
        why: 'It fits students who like turning real questions into evidence, charts, and clear conclusions.',
        strengths: 'Your coursework, campus research, or business curiosity can become analysis material quickly.',
        gaps: 'You may need to strengthen Excel, SQL, Python, and the ability to explain business meaning.',
        next: 'Start with one campus survey or public dataset and write a one-page conclusion.',
        outcome: 'A report, dashboard, or portfolio case that can be used in resume and interviews.',
      },
      frontend: {
        title: 'Frontend and product experience',
        why: 'It fits students who like visible work, interfaces, interaction, and fast feedback.',
        strengths: 'You can show ability through live pages, GitHub repositories, and product thinking.',
        gaps: 'You need responsive implementation, component structure, and real deployment experience.',
        next: 'Build a mobile-friendly portfolio page or campus activity signup page.',
        outcome: 'A live demo, README, and project story that proves product and engineering ability.',
      },
      backend: {
        title: 'Backend engineering',
        why: 'It fits students who like logic, systems, data models, and stable technical depth.',
        strengths: 'Course projects can become deployable systems with clear modules and APIs.',
        gaps: 'You need database design, API structure, authentication, and deployment practice.',
        next: 'Build one small management system with login, tables, and core CRUD flow.',
        outcome: 'A deployable system project with API docs, database design, and resume bullets.',
      },
      content: {
        title: 'Content operations',
        why: 'It fits students who can keep publishing, observe data, and understand platforms and users.',
        strengths: 'Non-technical majors can produce visible outcomes quickly through content and reviews.',
        gaps: 'You need consistent output, topic strategy, and data review instead of vague copywriting.',
        next: 'Choose one niche, publish seven pieces, and summarize the data pattern.',
        outcome: 'A content portfolio with topic logic, sample posts, and performance review.',
      },
      product: {
        title: 'Product assistant',
        why: 'It fits students who enjoy user problems, requirements, flows, and cross-team communication.',
        strengths: 'You can connect business, design, and technology through prototypes and product documents.',
        gaps: 'You need more structured PRDs, competitor analysis, data sense, and execution proof.',
        next: 'Pick a campus scenario, write a small PRD, and prototype three key screens.',
        outcome: 'A product case including problem, user flow, prototype, and review.',
      },
      public: {
        title: 'Public sector and stable track',
        why: 'It fits students who value stable development, structured expression, and long-term preparation.',
        strengths: 'Campus work, research, volunteering, and writing experience can become useful evidence.',
        gaps: 'You need sustained exam preparation, writing structure, and experience material organization.',
        next: 'Build an experience bank and start basic aptitude or writing review.',
        outcome: 'A preparation file with experience stories, writing material, and weekly review records.',
      },
    },
  },
  homeGrowth: {
    metaTitle: 'QingTu AI - College Growth and Career Planning Platform',
    metaDescription: 'QingTu AI helps college students find direction, plan growth, and move toward the future.',
    eyebrow: 'QingTu AI',
    title: 'Turn college growth into one useful step each day',
    titleLine1: 'Turn college growth',
    titleLine2: 'into one useful step each day',
    subtitle: 'From direction exploration to career preparation, QingTu AI helps you plan routes, build ability, complete projects, and move toward a better future.',
    routeIntro: 'Growth route: know yourself -> find direction -> make a plan -> complete tasks -> build outcomes',
    start: 'Start exploring my direction',
    continue: 'Continue my growth',
    checking: 'Checking growth plan...',
    secondary: 'Explore a new direction',
    secondaryGuest: 'Browse outcomes',
    knowMe: 'Help me know you better',
    partnerCardTitle: 'AI partner growth state',
    partnerUpdated: 'Updated today',
    partnerGuide: 'Waiting to know you',
    partnerObservation: 'Partner observation: you are moving toward "{{direction}}". Today, finish one visible small action.',
    partnerEmptyObservation: 'Partner observation: there is no growth record yet. Start with direction exploration and I will turn confusion into a next step.',
    heroSceneLabel: 'AI partner growth status preview',
    petSpeechTitle: 'Hi, I am your growth partner',
    petSpeechReady: 'Keep moving one small goal today.',
    petSpeechEmpty: 'Let me get to know you, then we will plan your direction.',
    companionPanelTitle: 'AI partner companion',
    companionPanelActive: 'Helping you move forward',
    companionPanelEmpty: 'Waiting to start',
    companionChat: 'Talk through current confusion',
    companionRecord: 'View growth records',
    companionNurture: 'Grow with your companion pet',
    emptyDirection: 'Direction to explore',
    emptyStage: 'Direction exploration',
    emptyAdvice: 'Complete one direction exploration',
    defaultAdvice: 'Finish the smallest useful step today',
    statusLabel: 'Growth state',
    statusTitle: 'Not a tool list, but your current progress',
    statusDirection: 'Current direction',
    statusStage: 'Current stage',
    statusAdvice: "Today's advice",
    statusProgress: 'Growth progress',
    overviewLabel: 'Growth data',
    overviewTitle: 'Your growth keeps becoming visible',
    overviewStreak: 'Growth streak',
    overviewTasks: 'Completed tasks',
    overviewProjects: 'Project experience',
    overviewCertificates: 'Certificates/outcomes',
    daysCount: '{{count}} days',
    notStarted: 'Not started',
    modulesLabel: 'Four growth modules',
    modulesTitle: 'Organized around a real student path',
    modulesDesc: 'Every module serves one goal: help you know the next step and leave evidence you can review and show.',
    moduleExploreTitle: 'Explore direction',
    moduleExploreDesc: 'Find a direction that fits your major, interests, habits, and current goal.',
    moduleLearningTitle: 'Learning route',
    moduleLearningDesc: 'Break the direction into stages and tasks so you can start without hoarding resources.',
    moduleProjectTitle: 'Project practice',
    moduleProjectDesc: 'Turn courses, practice, and ideas into visible project outcomes.',
    moduleCareerTitle: 'Career preparation',
    moduleCareerDesc: 'Organize resume materials, project stories, and interview preparation.',
    moduleCta: 'Enter',
    partnerLabel: 'AI partner',
    partnerTitle: 'Turn fuzzy thoughts into a next step',
    partnerDesc: 'The AI partner uses your direction, stage, tasks, and growth events to give advice closer to today.',
    partnerCta: 'Chat with AI partner',
    todayLabel: "Today's growth task",
    todayTitle: 'Move the most important step today',
    todayDesc: 'Your AI partner breaks your current direction and stage into tasks you can finish today.',
    todayEmptyDesc: 'Before you have a growth plan, complete one direction exploration and the AI partner will create first-stage tasks.',
    todayEmptyTask: 'Complete one direction exploration and build your growth profile',
    confusionLabel: 'Start from a real student problem',
    confusionTitle: 'Start from the problem you have now',
    confusionDesc: 'No direction, no rhythm, and no outcomes lead to three different paths.',
    confusionDirectionTitle: 'I do not know my direction',
    confusionDirectionDesc: 'Explore suitable paths from your major, interests, personality, and expected lifestyle.',
    confusionDirectionCta: 'Explore directions',
    confusionImproveTitle: 'I do not know how to improve',
    confusionImproveDesc: 'Turn a vague goal into a learning route, daily tasks, and reviewable progress.',
    confusionImproveCta: 'View my growth',
    confusionOutcomeTitle: 'I have no outcomes for jobs',
    confusionOutcomeDesc: 'Build projects, polish resumes, and collect proof that can be used in internships or applications.',
    confusionOutcomeCta: 'Build outcomes',
    loopLabel: 'Growth loop',
    loopTitle: 'The homepage only gets you to the next step',
    loopDesc: 'The later tools serve one growth path instead of being piled onto the homepage.',
    loopSelf: 'Know yourself',
    loopSelfDesc: 'Start with your grade, foundation, interests, and pressure.',
    loopDirection: 'Find direction',
    loopDirectionDesc: 'Compare paths that match your current situation.',
    loopPlan: 'Make a plan',
    loopPlanDesc: 'Break the direction into learnable stages.',
    loopTask: 'Complete tasks',
    loopTaskDesc: 'Focus on today instead of browsing features.',
    loopOutcome: 'Build outcomes',
    loopOutcomeDesc: 'Turn learning and practice into projects and resume evidence.',
    caseLabel: 'Student cases',
    caseTitle: 'Different students enter from different problems',
    caseDesc: 'The product should feel useful before students understand every feature.',
    casePrefix: 'Case',
    caseFreshmanTitle: 'Freshman who has not chosen a direction',
    caseFreshmanDesc: 'Starts with self-understanding and direction exploration, then saves a small first-semester action plan.',
    caseSophomoreTitle: 'Sophomore who feels behind',
    caseSophomoreDesc: 'Continues from the growth center, follows a weekly learning path, and uses tasks to regain rhythm.',
    caseInternTitle: 'Student preparing for internship',
    caseInternDesc: 'Goes straight to outcomes: project packaging, resume optimization, and GitHub evidence.',
    capabilityLabel: 'Product capabilities',
    capabilityTitle: 'Enter specific tools only when needed',
    capabilityDesc: 'Learning routes, projects, resumes, GitHub, and the AI partner remain available, but they serve your growth goal.',
    learningTitle: 'Learning routes',
    learningDesc: 'Follow a path that matches your goal and current foundation.',
    projectTitle: 'Projects',
    projectDesc: 'Turn coursework and practice into visible portfolio evidence.',
    resumeTitle: 'Resume',
    resumeDesc: 'Package experience into job-ready language and structure.',
    githubTitle: 'GitHub trends',
    githubDesc: 'Use trends as opportunity signals, not as an isolated tool list.',
    companionTitle: 'AI partner',
    companionDesc: 'Talk through your current situation and receive next-step guidance.',
    finalTitle: 'Start with your current state',
    finalDesc: 'You do not need to understand every feature first. Complete one direction exploration and QingTu AI brings you back to a daily growth path.',
  },
  authMarketing: {
    featuresAria: 'What QingTu AI helps with',
    loginTitle: 'Log in - QingTu AI',
    registerTitle: 'Create account - QingTu AI',
    loginDescription: 'Log in to QingTu AI and continue career planning, learning paths, projects, and career preparation.',
    registerDescription: 'Create a QingTu AI account and start planning your college growth journey.',
    title: 'Plan Your 4-Year College Growth Journey with AI',
    description: 'From exploration and learning to projects, resumes and career preparation, AI helps you grow step by step.',
    feature1Title: 'Career Exploration',
    feature1Desc: 'Find career directions and growth routes that fit you',
    feature2Title: 'AI Learning Plans',
    feature2Desc: 'Generate learning plans from your major, goals, and foundation',
    feature3Title: 'Project Practice',
    feature3Desc: 'Get project ideas, practice tasks, and hands-on routes',
    feature4Title: 'Career Preparation',
    feature4Desc: 'Resume optimization, job matching, and interview preparation',
    previewLabel: 'Growth route',
    previewTag: 'AI plan',
    previewTitle: 'College growth task card',
    previewDesc: 'Turn exploration, skill learning, project practice, and career preparation into daily actions.',
    badge1: 'Career planning',
    badge2: 'Learning path',
    badge3: 'Career prep',
  },
  auth: {
    inputUsername: 'Please enter a username.',
    inputEmail: 'Please enter an email address.',
    inputPassword: 'Please enter a password.',
    passwordLength: 'Password must be at least 8 characters.',
    passwordMismatch: 'The two passwords do not match.',
    turnstileMissing: 'Human verification is not configured. Please contact the administrator.',
    humanCheck: 'Please complete human verification.',
    turnstileLazyHint: 'The security check will load after you submit the registration form.',
    turnstileLoading: 'Loading the security check...',
    turnstileRetrying: 'The check did not complete. Getting a new verification...',
    turnstileVerified: 'Security check complete. Submitting your registration...',
    turnstileLoadFailed: 'Security verification failed to load. Please refresh and try again.',
    turnstileVerificationFailed: 'Security verification was not completed. Please try again.',
    turnstileRetry: 'Reload verification',
    turnstileUnavailable: 'Security verification is temporarily unavailable. Please try again later.',
    requestFailed: 'The request could not be completed. Please try again later.',
    loginHumanCheck: 'Please complete the login human check first.',
    verificationResent: 'Verification email has been sent again.',
    githubMissingUrl: 'GitHub login is temporarily unavailable.',
    githubLoginFailed: 'GitHub login failed. Please try account login.',
    emailVerification: 'Email verification',
    verifyTitle: 'Verify your email to activate the account',
    verifySent: 'We have sent a verification email to your inbox.',
    verifyCreated: 'Your account has been created. Please verify your email before logging in.',
    verifyNote: 'If you do not see it, check spam or resend the verification email.',
    resend: 'Resend email',
    emailVerified: 'I have verified, go to log in',
    turnstileProdMissing: 'Human verification is not configured. Registration is temporarily unavailable.',
    turnstileDevMissing: 'Human verification is skipped in local development.',
    registrationSuccessRedirect: 'Account created. We sent a verification email to: ',
    emailAlreadyExists: 'This email is already registered. Please sign in or reset your password.',
    usernameAlreadyExists: 'This username is already in use. Please choose another one.',
    unverified: 'This account has not verified its email yet.',
    resendNow: 'Resend verification email',
  },
  authForm: {
    loginHeading: 'Welcome back',
    registerHeading: 'Create your growth account',
    loginIntro: 'Log in to continue your learning path, project practice, resume optimization, and career preparation.',
    registerIntro: 'Create an account to save your growth route, learning plan, project practice, and career preparation progress.',
    githubLogin: 'Continue with GitHub',
    githubProcessing: 'Processing...',
    githubUnavailable: 'GitHub login is not configured',
    githubFallback: 'Please use username and password login.',
    divider: 'Or use account password',
    username: 'Username',
    usernameOrEmail: 'Username or email',
    usernamePlaceholder: 'Set your username',
    usernameOrEmailPlaceholder: 'Enter username or email',
    email: 'Email',
    emailPlaceholder: 'Used to receive verification email',
    password: 'Password',
    passwordPlaceholder: 'Enter password',
    newPasswordPlaceholder: 'At least 8 characters',
    confirmPassword: 'Confirm password',
    confirmPasswordPlaceholder: 'Enter password again',
    forgotPassword: 'Forgot local account password?',
    humanCheck: 'Human verification',
    loginHumanTitle: 'Confirm it is you before logging in',
    loginHumanDesc: 'This lightweight front-end check helps reduce repeated automated login attempts.',
    loginHumanQuestion: 'Enter the result of {{question}}',
    loginHumanPlaceholder: 'Answer',
    loginHumanRefresh: 'New question',
    submitLogin: 'Log in and continue',
    submitRegister: 'Sign up and send verification email',
    completeHumanCheck: 'Complete the security check above',
    processing: 'Processing...',
    hasAccount: 'Already have an account?',
    noAccount: 'No account yet?',
    goLogin: 'Log in',
    createAccount: 'Create account',
  },
  growthMentor: {
    eyebrow: 'AI Growth Mentor',
    title: 'Do the most important next step today',
    currentGoal: 'Current goal',
    currentStage: 'Current stage',
    learningProgress: 'Learning progress',
    recentStatus: 'Recent status',
    statusActive: 'Moving steadily',
    statusSlowing: 'Slowing down',
    statusQuiet: 'Needs restart',
    noGoal: 'No goal yet',
    noStage: 'No stage yet',
    todayAdvice: 'Today advice',
    weeklyReport: 'Weekly growth report',
    learningTime: 'Learning time',
    completedTasks: 'Completed tasks',
    abilityChange: 'Ability change',
    weakPoints: 'Weak points',
    nextWeek: 'Next week',
    projectProgress: 'Project progress',
    minutes: '{{count}} min',
    tasks: '{{count}} tasks',
    score: '{{count}} pts',
    weakPractice: 'Practice score is low',
    weakLearning: 'Learning completion is low',
    weakProject: 'Project progress is low',
    weakEmpty: 'No obvious weak point this week',
    advice: {
      restart: 'Spend 20 minutes finishing one small task to restart your rhythm.',
      practice_fix: 'Fix the latest low-score practice before moving on.',
      practice_review: 'Review recent practice feedback and patch one weak concept.',
      project_push: 'Turn recent learning into a project task and submit one milestone.',
      learning_next: 'Continue the next learning node in your current stage.',
      weekly_review: 'Do a weekly review and turn project output into resume wording.',
    },
    reasons: {
      recent_activity: 'Latest activity: {{value}}',
      no_activity: 'No recent growth activity yet',
    },
    actions: {
      open_project_workspace: 'Open project factory',
      submit_project_result: 'Submit milestone',
      review_growth_assets: 'Review growth assets',
      open_practice_center: 'Open practice center',
      review_feedback: 'Review AI feedback',
      retry_one_practice: 'Retry one practice',
      continue_learning: 'Continue learning path',
      finish_today_task: 'Finish today task',
    },
    nextWeekAdvice: {
      next_week_project: 'Next week, focus on one presentable project outcome.',
      next_week_practice: 'Next week, improve practice consistency and pass rate.',
      next_week_review: 'Next week is good for project review and career material cleanup.',
    },
  },
  growthCompanion: {
    metaTitle: 'AI Growth Companion - QingTu AI',
    metaDescription: 'Chat with an AI growth companion to build a student growth profile, memory, and daily advice.',
    eyebrow: 'AI Growth Companion',
    title: 'A growth partner that gets to know you over time',
    subtitle: 'Chat naturally about your major, year, interests, habits, goals, difficulties, and personality tendency.',
    loginTitle: 'Log in to start your AI growth companion',
    loginDesc: 'You can first see what it helps with. After login, conversations can be saved and synced to My Growth.',
    tryExplore: 'Explore direction first',
    guestPreviewTitle: 'What the AI partner helps with',
    guestPreviewHeading: 'Turn vague worries into one next action',
    guestValueClarify: 'Clarify confusion: split a vague worry into direction, ability, and real constraints.',
    guestValueNext: 'Create a next step: turn the chat into one small action you can start today.',
    guestValueSync: 'Sync to My Growth: after login, goals, tasks, and advice can be saved to your growth center.',
    exampleTitle: 'You can start like this',
    exampleDirection: 'I am a freshman and do not know what direction fits me.',
    exampleBehind: 'I am a sophomore and feel behind. Should I improve projects or fundamentals first?',
    exampleInternship: 'I am preparing for internships, but my projects and resume are weak.',
    start: 'Start companion chat',
    send: 'Send',    thinking: "I'm reading this project",
    placeholder: 'For example: I am a sophomore in software engineering, interested in backend, but my projects are weak...',
    generateProfile: 'Generate growth profile',
    notQuestionnaire: 'This is not a fixed questionnaire',
    notQuestionnaireDesc: 'Say what feels most important first. The companion will gently follow up instead of asking you to fill every field.',
    profileTitle: 'Personal growth profile',
    currentStatus: 'Current status',
    strengths: 'Strengths',
    weaknesses: 'Gaps',
    recommendedDirection: 'Recommended direction',
    futureAdvice: 'Future advice',
    exploring: 'Exploring direction',
    dailyAdvice: 'Today advice',
    noRecentReason: 'No recent activity yet',
    longTerm: 'Long-term information',
    shortTerm: 'Short-term status',
    preferences: 'Preferences',
    emptyLongTerm: 'Your longer-term direction will appear here after a conversation.',
    emptyShortTerm: 'Your current focus will appear here after you start chatting.',
    emptyPreferences: 'Learning habits and preferences you mention will appear here.',
    errorStart: 'Could not start the companion. Please try again later.',
    errorSend: 'Message failed. Please try again later.',
    errorProfile: 'Could not generate the profile. Please try again later.',
    adjustmentTitle: 'Plan adjustment draft',
    adjustmentUnchanged: 'Your current plan has not been changed. Review this draft before applying it.',
    adjustmentDailyTime: 'Suggested daily time',
    adjustmentReason: 'Reason',
    adjustmentChanges: 'Suggested changes',
    minutes: 'minutes',
    applyAdjustment: 'Apply this adjustment',
    keepCurrentPlan: 'Keep current plan',
    adjustmentApplied: 'The adjustment was applied as a new plan version.',
    adjustmentDismissed: 'The draft was dismissed. Your current plan is unchanged.',
    errorAdjustment: 'Could not update the plan. Please try again.',
    versionHistory: 'Plan version history',
    versionHistoryTitle: 'Review how your plan changed',
    versionHistoryDesc: 'Restoring a version creates a new active copy. Existing history is never deleted.',
    currentVersion: 'Current version',
    historyVersion: 'History version',
    unnamedPlan: 'Growth plan',
    originalGeneratedPlan: 'Original AI-generated plan',
    restoreVersion: 'Restore this version',
    versionRestored: 'The selected version was restored as a new active plan.',
    errorVersionRestore: 'Could not restore this version. Refresh and try again.',
    weeklyTasks: 'Seven-day execution plan',
    weeklyTasksTitle: 'Turn the current plan into one task per day',
    weeklyTasksDesc: 'Tasks come from the stages in your active plan. Completion and difficulty feedback help the companion suggest later adjustments.',
    generateWeeklyTasks: 'Generate my seven-day tasks',
    completeTask: 'Complete',
    tooHard: 'Too hard',
    skipTask: 'No time / skip',
    errorWeeklyTasks: 'Could not generate the seven-day tasks. Please try again.',
    errorTaskAction: 'Could not update this task. Please try again.',
    taskStatus: {
      pending: 'Pending',
      completed: 'Completed',
      skipped: 'Skipped',
    },
    adjustmentSuggested: 'This week may need a lighter plan',
    createAdjustmentDraft: 'Create an adjustment draft',
    evaluationReason: {
      too_hard: 'Several tasks were marked too hard. Consider reducing difficulty while keeping the same career goal.',
      no_time: 'Several tasks were skipped because time was unavailable. Consider reducing the daily workload.',
      low_completion: 'The completion rate is below 50% after several attempts. Consider narrowing the next actions.',
    },
    companion: {
      greeting: 'Hi, I will get to know you gently. Start with your major, year, or what feels most confusing lately.',
      ready_report: 'I have enough context for a first profile. You can generate it now, then keep chatting later.',
      ask: {
        major: 'What is your major or field? It helps me judge which growth route fits you.',
        grade: 'Which year are you in now? The advice will be different for freshman and senior years.',
        goal: 'What direction or outcome do you most want in the next 6-12 months?',
        difficulty: 'What is the biggest thing blocking you right now?',
        habit: 'How do you usually learn best: videos, projects, reading, practice, or deadlines?',
        personality: 'What is your usual working style: steady, curious, anxious, independent, social, or something else?',
      },
    },
    daily: {
      start_small: 'Start with one small growth action today.',
      continue_learning: 'Continue the next learning task.',
      fix_practice: 'Fix one weak practice result first.',
      push_project: 'Move one project task forward today.',
      weekly_review: 'Do a short review and turn progress into evidence.',
    },
    adviceItems: {
      choose_one_30_day_goal: 'Choose one 30-day goal.',
      keep_small_daily_actions: 'Keep the next action small enough to repeat.',
      turn_learning_into_project_evidence: 'Turn learning into project evidence.',
    },
  },
  student: {
    eyebrow: 'Student Zone',
    title: 'Not sure what to learn? Start here',
    subtitle: 'Based on your year, direction, and goal, get project ideas, skill routes, resume highlights, and job-search preparation steps that fit you.',
    modulesAria: 'College student AI growth toolbox modules',
    modules: {
      competition: {
        title: 'Competition Radar',
        scene: 'For students who want awards, campus points, and stronger resume proof, starting with suitable competitions.',
        points: {
          0: 'Find college competitions that match your major and year',
          1: 'Filter by timeline, difficulty, and recognition',
          2: 'Generate a registration preparation checklist',
        },
        button: 'View competition opportunities',
        hint: 'Best for students seeking awards, evaluation points, and resume depth',
      },
      aiTools: {
        title: 'AI Toolbox',
        scene: 'Organize paper, PPT, report, translation, and resume tools by task instead of searching from scratch.',
        points: {
          0: 'Recommendations for paper, PPT, report, translation, and resume tools',
          1: 'Grouped by study, office work, and job search',
          2: 'Save frequently used tools',
        },
        button: 'View AI tools',
        hint: 'Best for daily study and assignment efficiency',
      },
      growth: {
        title: 'Major Growth Route',
        scene: 'For students who are unsure what to learn, what projects to build, or how to prepare for internships.',
        points: {
          0: 'Generate a learning route based on your major direction',
          1: 'Recommend skills, projects, certificates, and internship prep',
          2: 'Expandable for CS, business, design, mechanical, electrical, and more',
        },
        button: 'Generate growth route',
        hint: 'Best for students unsure what to learn during college',
      },
      resume: {
        title: 'Resume Optimization',
        scene: 'Turn competitions, coursework, projects, and internship experience into clearer resume material.',
        points: {
          0: 'Upload a resume PDF / Word file',
          1: 'AI analyzes problems and gives revision suggestions',
          2: 'Generate an optimized resume structure and project descriptions',
        },
        button: 'Upload resume for optimization',
        hint: 'Best for internships, campus recruiting, and competition applications',
      },
    },
    scenariosEyebrow: 'How to use it',
    scenariosTitle: 'Start with one real problem',
    scenarios: {
      competition: {
        title: 'I want to join competitions, but do not know which ones fit',
        button: 'Find competitions for me',
      },
      tools: {
        title: 'I want to improve assignment, PPT, and paper efficiency',
        button: 'Recommend study tools',
      },
      internship: {
        title: 'I want to prepare for internships, but my resume and projects are weak',
        button: 'Plan internship prep',
      },
    },
    emptyEyebrow: 'Sample recommendations',
    emptyTitle: 'Local development still has content',
    emptyMessage: 'You are in a local development environment with no online data yet. You can review sample recommendations first.',
    examples: {
      competitions: {
        title: 'Sample competitions',
        items: {
          0: 'China International College Students Innovation Competition: good for teams with an early project',
          1: 'Challenge Cup: good for research, social studies, and startup plans',
          2: 'China Undergraduate Mathematical Contest in Modeling: good for students with math and coding foundations',
        },
      },
      tools: {
        title: 'Sample AI tools',
        items: {
          0: 'Paper reading assistant: extracts abstracts, methods, and conclusions',
          1: 'PPT outline generator: builds structure from a course topic',
          2: 'Resume project writer: turns experience into outcome-driven bullets',
        },
      },
      routes: {
        title: 'Sample growth routes',
        items: {
          0: 'Computer Science: data structures, web project, open-source reproduction, summer internship',
          1: 'Business: data analysis, business cases, certificate prep, industry research',
          2: 'Design: portfolio, interaction prototype, visual system, internship applications',
        },
      },
    },
    heroActions: {
      choose: 'Choose my direction',
      projects: 'Show suitable projects',
      resume: 'Upload resume for advice',
    },
    heroPanel: {
      label: 'Student growth summary',
      title: 'A practical plan before another random tutorial',
      description: 'Pick who you are now, choose one goal, then follow a small project and a concrete next-step list.',
    },
    identityEyebrow: 'Student identity',
    identityTitle: 'Which situation sounds most like you?',
    identities: {
      early: {
        stage: 'Freshman / Sophomore',
        title: 'I do not know what to learn yet',
        description: 'Find beginner-friendly skills, tools, and practice projects.',
      },
      senior: {
        stage: 'Junior / Senior',
        title: 'Preparing for internships and resumes',
        description: 'Get resume-ready projects, skill gaps, and interview prep directions.',
      },
      thesis: {
        stage: 'Graduation project',
        title: 'I need a project topic',
        description: 'Find deployable and demonstrable project directions for a thesis or capstone.',
      },
      beginner: {
        stage: 'Transfer / Zero foundation',
        title: 'Start from zero',
        description: 'Use lower-barrier routes into AI, development, data analysis, or automation tools.',
      },
      sideIncome: {
        stage: 'Side income / Freelance',
        title: 'Build a portfolio that can earn',
        description: 'Find small projects suitable for presentation, freelancing, and monetization.',
      },
    },
    goalEyebrow: 'Current goal',
    goalTitle: 'Choose what you want to achieve first',
    goals: {
      internship: 'Find an internship',
      thesis: 'Build a thesis project',
      resume: 'Improve my resume',
      aiTools: 'Learn AI tools',
      personalProject: 'Build a personal project',
      sideIncome: 'Earn side income',
      competition: 'Competition / innovation',
    },
    projectsEyebrow: 'Recommended projects',
    projectsTitle: 'Projects that explain what to do next',
    projectsDescription: 'These are static V1.1 recommendations. They change by your identity and goal, without requiring backend data.',
    projectFields: {
      time: 'Estimated time',
      resume: 'Resume sentence',
      skills: 'Skills',
      targets: 'Best for',
    },
    projectActions: {
      idea: 'View project idea',
      route: 'Generate learning route',
      plan: 'Add to my plan',
    },
    projects: {
      aiResume: {
        name: 'AI Resume Optimization Assistant',
        audience: 'For internship prep and resume improvement',
        difficulty: 'Intermediate',
        time: '2 weeks',
        resume: 'Built an intelligent resume tool that supports resume upload, AI analysis, and optimization suggestions.',
        skills: {
          0: 'Frontend',
          1: 'Backend',
          2: 'AI API',
          3: 'File upload',
        },
        targets: {
          0: 'Internship',
          1: 'Resume',
          2: 'Portfolio',
          3: 'AI tool',
        },
      },
      campusMarket: {
        name: 'Campus Second-hand Marketplace',
        audience: 'For thesis projects and Java backend practice',
        difficulty: 'Intermediate',
        time: '2 weeks',
        resume: 'Designed and implemented a campus marketplace with item publishing, search, favorites, and transaction status management.',
        skills: {
          0: 'Spring Boot',
          1: 'MySQL',
          2: 'Auth',
          3: 'Product management',
        },
        targets: {
          0: 'Thesis',
          1: 'Practice',
          2: 'Resume',
          3: 'Demo',
        },
      },
      studyTracker: {
        name: 'Learning Task Tracker App',
        audience: 'For freshmen, sophomores, and beginners',
        difficulty: 'Beginner',
        time: '3 days',
        resume: 'Built a personal learning planner with task breakdown, progress tracking, and daily review.',
        skills: {
          0: 'React',
          1: 'State management',
          2: 'Local storage',
          3: 'UI design',
        },
        targets: {
          0: 'Practice',
          1: 'Personal project',
          2: 'Portfolio',
          3: 'Study',
        },
      },
      aiNotes: {
        name: 'AI Study Material Organizer',
        audience: 'For AI tool learning and study efficiency',
        difficulty: 'Intermediate',
        time: '1 week',
        resume: 'Built an AI study organizer that supports document summaries, key point extraction, and review card generation.',
        skills: {
          0: 'File parsing',
          1: 'Summarization',
          2: 'Knowledge cards',
          3: 'AI workflow',
        },
        targets: {
          0: 'AI tools',
          1: 'Study',
          2: 'Portfolio',
          3: 'Competition',
        },
      },
      githubAnalyzer: {
        name: 'GitHub Project Analyzer',
        audience: 'For CS students and job-search portfolios',
        difficulty: 'Challenge',
        time: '2 weeks',
        resume: 'Implemented a GitHub repository analysis tool that evaluates project quality, tech stack, and resume value automatically.',
        skills: {
          0: 'GitHub API',
          1: 'AI analysis',
          2: 'Data display',
          3: 'Report generation',
        },
        targets: {
          0: 'Internship',
          1: 'Portfolio',
          2: 'Resume',
          3: 'Freelance demo',
        },
      },
    },
    nextEyebrow: 'Next actions',
    nextTitle: 'What to do next',
    nextButton: 'Generate a fuller growth plan',
    actions: {
      senior_internship: {
        0: 'Pick one project that can be written on your resume',
        1: 'Use 7 days to finish the core features',
        2: 'Generate a clear project resume sentence',
        3: 'Upload your resume for AI optimization',
        4: 'Prepare interview questions from the project',
      },
      thesis: {
        0: 'Choose a project direction that can be implemented',
        1: 'Clarify feature modules and database tables',
        2: 'Draft the proposal and requirement analysis',
        3: 'Build a demonstrable version',
        4: 'Prepare the defense explanation',
      },
      early_internship: {
        0: 'Start with a small beginner project',
        1: 'Learn the minimum skills needed for that project',
        2: 'Record screenshots and progress every day',
        3: 'Turn the project into a resume-ready description',
        4: 'Review internship job descriptions early',
      },
      beginner_aiTools: {
        0: 'Choose one AI workflow you can use every week',
        1: 'Build a small tool around real study material',
        2: 'Write down before-and-after efficiency changes',
        3: 'Package it as a portfolio demo',
        4: 'Add one feature that classmates would actually use',
      },
      sideIncome_sideIncome: {
        0: 'Choose a small tool with a clear user',
        1: 'Make a landing screenshot and demo flow',
        2: 'Prepare a simple pricing or service package',
        3: 'Collect feedback from 3 potential users',
        4: 'Turn the project into a portfolio case',
      },
      default: {
        0: 'Choose one realistic project direction',
        1: 'Break it into 3 core features',
        2: 'Finish a usable demo first',
        3: 'Write a resume sentence for the result',
        4: 'Decide the next skill to improve',
      },
    },
    quick: {
      competition: 'Find competitions',
      tools: 'Browse AI tools',
      resume: 'Resume advice',
    },
  },
  careerAssistant: {
    title: 'Job-Focused Career Assistant',
    entryTitle: 'Job-Focused Career Assistant',
    entryDescription: 'Paste a target job description. AI parses role requirements, improves your resume, generates interview questions, and supports mock interviews.',
    entryButton: 'Start targeted prep',
  },
  pagination: {
    aria: 'Pagination',
    summary: 'Page {{page}} / {{totalPages}}, {{total}} items',
  },
  report: {
    badge: 'Open Source Report',
    viewGithub: 'View GitHub',
    generateHealth: 'Generate project report',
    share: 'Share report',
    copyPromo: 'Copy promo text',
    copyGithubLink: 'Copy GitHub link',
    save: 'Save',
  },
  stats: {
    stars: 'Stars',
    forks: 'Forks',
    openIssues: 'Open issues',
    language: 'Primary language',
    todayGrowth: 'Today growth',
    lastPush: 'Last push',
    starTotal: 'Total GitHub stars',
    starGrowth: 'Star growth',
    communityReuse: 'Community reuse and forks',
    publicIssueCount: 'Public issue count',
    primaryLanguage: 'Primary language',
    lastPushDesc: 'Latest push time',
    trendStatus: 'Trend status',
    firstEntry: 'First entry',    firstRanking: "First time on today's ranking",
    siteViews: 'Accumulated project detail views on this site',
    siteSaves: 'Accumulated user saves on this site',
    latestRanking: 'Latest ranking record',
  },
  project: {
    collectedOn: 'Collected on {{date}}',
    updatedOn: 'Updated on {{date}}',
    continuousAiInsight: 'Continuous AI insight',
    owner: 'Owner',
    languageEcosystem: '{{language}} ecosystem',
    openSourceProject: 'Open-source project',
    worthWatching: 'Worth watching',
    keepWatching: 'Keep watching',
    aiTool: 'AI tool',
    highHeat: 'High heat',
    goodForLearning: 'Good for learning',
    resumeReady: 'Resume-ready',
    goodForForking: 'Good for forking',
    advancedCaution: 'Advanced caution',
    advanced: 'Advanced',
    modularLearning: 'Good for module-by-module learning',
    noSummary: 'No project interpretation yet.',
    noReason: 'No attention reason yet.',
    noLearningValue: 'No learning value yet.',
    noLearningDirection: 'Not enough project information to judge learning directions yet.',
    noTechHighlights: 'Not enough project information for technical highlights yet.',
    noDifficulty: 'Not enough project information to judge difficulty yet.',
    noResumeAngle: 'Not enough project information to form a resume angle yet.',
    noTrendSnapshot: 'No trend snapshot data yet.',
    riskNoLicense: 'License information is unclear. Confirm the license scope before reuse or commercial use.',
    riskFallback: 'This interpretation is based on basic project data. Use the repository README and source code for technical judgment.',
    riskAdvanced: 'This project may have a higher entry bar. Check prerequisites, runtime environment, and dependency cost first.',
    riskDefault: 'Before adopting it, review the README, issues, release frequency, and dependency safety.',
  },
  landing: {
    eyebrow: 'GitHub Project Analysis',
    title: 'Turn worthwhile GitHub projects into reports for learning, resumes, and interviews.',
    description: 'Paste a repository URL to summarize the project, tech stack, highlights, learning value, resume angles, interview talking points, and improvement ideas. You can also browse trending open-source projects and useful tools.',
    analyzeNow: 'Analyze a GitHub project',    todayHot: "View today's hot projects",
    enterTools: 'Enter user tools',
    petEyebrow: 'AI Pet Assistant',
    petTitle: 'Feed great projects to your AI pet',
    petDescription: 'Drag a GitHub project to the AI pet and it will help analyze project value, tech stack, and resume angles.',
    tryFeed: 'Try feeding a project',
    productAria: 'Product highlights',
    productAnalysisTitle: 'GitHub Project Analysis',
    productAnalysisDescription: 'Extract learning value, resume angles, and interview notes from READMEs, tech stacks, and activity signals.',
    productToolsTitle: 'Open-source tool discovery',
    productToolsDescription: 'Find tools worth learning, trying, saving, and using without wasting time filtering noise.',
    productPetTitle: 'AI Pet Assistant',
    productPetDescription: 'A lightweight pet assistant for questions, project feeding, check-ins, and interactive tasks.',
    feedbackQuestion: 'Was this analysis useful?',
    feedbackHelpful: 'Useful',
    feedbackNeutral: 'Okay',
    feedbackInaccurate: 'Inaccurate',
    feedbackThanks: 'Thanks, feedback recorded',
    entryTools: 'For Everyone',
    entryToolsDesc: 'Open-source tools, categories, details, downloads, and saves.',
    entryStudent: 'Student Zone',
    entryStudentDesc: 'Get project ideas, competitions, learning roadmaps, and resume advice based on your major, grade, and goals.',
    entryAnalysis: 'GitHub Analysis',
    entryAnalysisDesc: 'Paste a GitHub repo URL and generate highlights, tech stack, improvements, and interview notes.',
    entryDeveloper: 'Developer',
    entryDeveloperDesc: 'GitHub trends, favorites, and developer tools.',
    entryProfileDescUser: 'View account, favorites, toolbox, and browsing history.',
    entryProfileDescGuest: 'Log in to view account, favorites, and toolbox.',
    entryAdminDesc: 'View users, traffic, tool clicks, downloads, and subscription stats.',
  },
  tools: {
    ordinaryTitle: 'Discover free open-source tools that regular people can actually use.',
    ordinaryDescription: 'GitHub projects are organized into plain-language tool cards with use cases, target users, difficulty, demos, and download links in one place.',
    ordinaryEyebrow: 'For Everyone',
    developerZone: 'Developer zone',
    searchPlaceholder: 'Search free tools, AI, PDF, PPT, alternatives...',
    searchPrefix: 'Search: {{query}}',
    searchTools: 'Search tools',
    todayPicks: "Today's picks",
    taskEyebrow: 'Find tools by problem',
    taskTitle: 'What kind of tool do you need today?',
    alternatives: 'Free alternatives',
    moreEyebrow: 'More recommendations',
    moreRecommended: 'More open-source tools',
    reset: 'Reset',
    loading: 'Organizing open-source tools',
    emptyTitle: 'No matching tools yet',
    emptyMessage: 'Try another problem or category.',    dailyDateFallback: "Today's picks",
    dailyTitle: '3 open-source picks today',
    dailyDescription: 'Three picks a day to help you quickly find free tools worth saving.',
    dailyItem: 'Pick {{index}}',
    recommendedTools: 'Recommended tools',
    today: 'Today',
    toolbox: 'Toolbox',
    toolboxTitle: 'Your toolbox entry',
    toolboxEmpty: 'Your toolbox is empty. Save a tool to get started.',
    viewProfile: 'View profile',
    followUpdates: 'Follow updates',
    followUpdatesTitle: 'Updates from tools you follow',
    followUpdatesEmpty: 'Follow tools to see releases, packages, and popularity changes here.',
    exploration: 'Exploration',
    explorationTitle: 'Exploration streak',
    explorationEmpty: 'Discover one tool a day and gradually build your personal toolbox.',
    personalizedTitle: 'Recommended for you today',
    personalizedEmpty: 'Use categories or search first; recommendations will improve over time.',
    commonEntry: 'Common entry',
    freeAiTools: 'Free AI tools',
    alternativeEntry: 'Alternatives',
    directExperience: 'Online experience',
    experienceFallback: 'The demo link looked unavailable, so the project homepage was opened instead.',
    experienceOpenFailed: 'Could not open the link. Please try again later.',
    experienceOpened: 'Online experience opened.',
    experiencePopupBlocked: 'Your browser may have blocked the new window. Allow pop-ups and try again.',
    experienceInvalidUrl: 'The experience link is invalid and cannot be opened.',
    experienceOpening: 'Opening online experience...',
    experienceUnavailableMessage: 'This tool does not have an available online experience link yet. View the project details or source code first.',
    feedPet: 'Feed to pet',
    addToolbox: 'Add to toolbox',
    inToolbox: 'In toolbox',
    noCode: 'No code needed',
    mayNeedConfig: 'May need setup',
    hasDemo: 'Online demo',
    noDemo: 'No online demo',
    freeOpenSource: 'Free / Open source',
    suitableFor: 'Best for',
    solves: 'Solves',
    useLevel: 'Difficulty',
    replacementFor: 'Can replace',
    defaultTargetUsers: 'People looking for free tools',
    defaultUseLevel: 'Read the project docs first',
    defaultReplacement: 'No clear replacement yet',
    loginForToolbox: 'Log in to add this to your toolbox',
    addedToolbox: 'Added to your toolbox',
    loginForFollow: 'Log in to follow tool updates',
    followedTool: 'Tool updates followed',
    category: {
      freeAi: 'Free AI tools',
      learningResearch: 'Study / Research tools',
      officeProductivity: 'Office productivity',
      imageVideoDesign: 'Image / Video / Design',
      writingMedia: 'Writing / Media',
      freeAlternatives: 'Free alternatives',
      sideProjectSite: 'Side projects / Personal sites',
      funProjects: 'Fun projects',
      developerProjects: 'Developer projects',
    },
    categoryDesc: {
      freeAi: 'Chat, summaries, images, PPT',
      learningResearch: 'PDFs, notes, research material',
      officeProductivity: 'Docs, sheets, meeting notes',
      imageVideoDesign: 'Editing, video, covers, design assets',
      writingMedia: 'Ideas, copy, layout, creator workflow',
      freeAlternatives: 'Alternatives to Notion, PDF, and AI tools',
      sideProjectSite: 'Side-project tools, personal sites, automation',
      funProjects: 'Novel ideas, experiments, inspiration',
      developerProjects: 'Frameworks, starters, source learning',
      fallback: 'Discover more free open-source tools',
    },
  },
  developer: {
    zone: 'Developer Zone',
    title: 'Developer Zone',
    listTitle: 'Developer tool list',
    description: 'A hub for GitHub trend reports, AI project analysis, favorites, and developer-focused tools. Keep filtering repos that are reproducible, learnable, and adaptable into your own projects.',
    ordinaryTools: 'User tools',
    searchPlaceholder: 'Search languages, frameworks, CLIs, templates, AI engineering projects...',
    filterProjects: 'Filter projects',
    allProjects: 'All developer projects',
    allDescription: 'Browse the current project pool and open a developer detail page from each card.',
    loading: 'Organizing developer projects',
    emptyTitle: 'No matching projects',
    emptyMessage: 'Refresh the developer project pool later.',
    back: 'Back to developer zone',
    dailyTrends: 'GitHub Trends',
    todayProjects: 'Open-source projects worth viewing today',
    dailyDescription: 'Uses the current trends API while keeping favorites, sharing, and detail links intact.',
    fullDaily: 'View full daily report',
    analysisEntry: 'AI project analysis',
    favorites: 'My favorites',
    developerTools: 'Developer tools',    selectedToday: "Today's developer picks",
    reproducible: 'Good projects to reproduce',
    resume: 'Resume-worthy projects',
    sourceStudy: 'Source code worth studying',
    popularStacks: 'Popular stack projects',
  },
  repo: {
    detailReport: 'Open-source project report',
    viewGithub: 'View GitHub',
    generateHealth: 'Generate project report',
    shareReport: 'Share report',
    copyPromotion: 'Copy promo text',
    copiedPromotion: 'Promo text copied',
    copyGithub: 'Copy GitHub link',
    copiedGithub: 'GitHub link copied',
    saved: 'Saved',
    aiInterpretation: 'AI project interpretation',
    projectSummary: 'Project summary',
    whyWorth: 'Why it is worth attention',
    targetUsers: 'Target users',
    learningValue: 'Project learning value',
    heatMetrics: 'Popularity metrics',
    beforeAdopt: 'Before adopting',
    projectInfo: 'Project info',
    linksAndTags: 'Links and tags',
    projectHomepage: 'Project homepage',
    adminActions: 'Admin actions',
    regenerateAi: 'Regenerate AI interpretation',
    regenerating: 'Regenerating',
    descriptionFallback: 'This project has not provided a GitHub description yet.',
    collectedAt: 'Collected on {{date}}',
    updatedAt: 'Updated on {{date}}',
    insightContinuous: 'Continuous AI insight',
    insightHistorical: 'Historical AI insight',
    insightFallback: 'Basic description fallback',
    aiPendingRetry: 'Retry needed',
    learningSubtitle: 'Learning and resume angles based on the current project interpretation',
    trendSubtitle: 'Keeps existing views, saves, heat, and ranking records',
    riskSubtitle: 'Quick notes before learning from or saving this project',
    learningDirection: 'Learning directions',
    techHighlights: 'Technical highlights',
    learningDifficulty: 'Learning difficulty',
    resumeAngle: 'Resume angle',
    learningAdvice: 'Learning advice',
    heatScore: 'Overall heat',
    views: 'Views',
    favorites: 'Saves',
    rankingIncluded: 'Ranking entry',
    fullName: 'Full name',
    primaryLanguage: 'Primary language',
    license: 'License',
    openIssues: 'Open issues',
    createdAt: 'Created',
    pushedAt: 'Last push',
    includedDate: 'Included date',
    insightSource: 'Insight source',
    generatedAt: 'Generated',
  },
  toolDetail: {
    backTools: 'Back to tools',
    ordinaryEyebrow: 'Tool details',
    developerEyebrow: 'Developer project analysis',
    letPetAnalyze: 'Let pet analyze',
    directExperience: 'Online experience',
    sourceAndDownload: 'Source and downloads',
    experienceDownload: 'Demo and downloads',
    whatIsIt: 'What does this tool do?',
    solves: 'What problems does it solve?',
    suitableFor: 'Who is it for?',
    howStart: 'How to start',
    pros: 'Pros',
    cons: 'Cons',
    onlineDownload: 'Demo / Downloads',
    useLevel: 'Difficulty',
    replacement: 'What can it replace?',
    saveTool: 'Save this tool',
    techStack: 'Tech stack',
    learningValue: 'Learning value',
    reproductionDifficulty: 'Reproduction difficulty',
    sourceHighlights: 'Source highlights',
    resumeValue: 'Resume value',
    extensionIdeas: 'Extension ideas: how to turn it into your own project',
    deploymentAdvice: 'Deployment advice',
    repoInfo: 'GitHub repo info',
    developerEntry: 'Developer entry',
    noExplicit: 'No clear details yet.',
    projectFileNotice: 'Downloaded project files are not always ordinary software installers. If you are not familiar with setup and running steps, try the online demo first.',
    noOnlineDemo: 'No online demo found yet.',
  },
  projectHealth: {
    eyebrow: 'Project Checkup',
    title: 'GitHub Project Analysis',
    description: 'Turn a GitHub project into a report for learning, resumes, and interviews.',
    guestTitle: 'Log in to generate and save GitHub project analyses.',
    guestDescription: 'After logging in, you can view history, refresh reports, and keep improving your project highlights and interview notes.',
    goLogin: 'Log in',
    inputTitle: 'Enter a GitHub repository URL',
    inputDescription: 'Supports https://github.com/owner/repo, .git, git@github.com:owner/repo.git, or owner/repo.',
    repoAddress: 'Repository URL',
    repoPlaceholder: 'Paste a GitHub project link, for example https://github.com/vercel/next.js',
    start: 'Start analysis',
    creating: 'Creating...',
    invalidRepo: 'Enter a valid GitHub repository URL, for example https://github.com/owner/repo',
    invalidRepoFormat: 'Invalid link format. Paste a GitHub project link such as https://github.com/vercel/next.js or owner/repo.',
    githubRepoNotFound: 'No public project was found. Check the link or confirm the repository is not private.',
    githubRateLimited: 'GitHub API is temporarily rate limited. Try again later or configure GITHUB_TOKEN.',
    aiAnalysisFailed: 'AI analysis failed. Please try again later.',
    networkError: 'Network error. Check the local service or deployment configuration.',
    myGithubProjects: 'My GitHub Projects',
    myGithubProjectsDescription: 'Your analyzed GitHub projects will appear here so you can re-analyze them or review previous reports.',
    noSavedGithubProjects: 'No saved GitHub projects yet. Analyze a project and it will appear here.',
    syncGithubProjects: 'Sync my GitHub projects',
    githubSyncFailed: 'Failed to sync GitHub projects. Try again later.',
    historyEyebrow: 'History',
    historyTitle: 'Reports',
    historyDescription: 'Shows your latest 50 project reports, sorted by update time.',
    loadingHistory: 'Loading reports',
    emptyHistoryTitle: 'No project reports yet',
    emptyHistoryMessage: 'Enter a GitHub repository URL and created reports will appear here.',
    viewDetail: 'View details',
    refresh: 'Refresh',
    refreshReport: 'Refresh report',
    reanalyze: 'Analyze again',
    deleteReport: 'Delete report',
    selectReport: 'Select a report',
    selectReportMessage: 'Click View details in the report history.',
    detailEyebrow: 'Report details',
    score: 'Score',
    generatedAt: 'Generated',
    refreshedAt: 'Refreshed',
    summary: 'Summary',
    errorInfo: 'Error',
    progress: 'Analysis progress',
    reportContent: 'Report content',
    copyShare: 'Create share link',
    copyPromotion: 'Copy promo text',
    poster: 'Create poster',
    openShare: 'Open shared report',
    pendingMessage: 'Analyzing GitHub data, README, and project activity. This usually takes 20-60 seconds.',
    createNotice: 'Report task created. Starting GitHub data fetching and AI analysis.',
    existingNotice: 'Reused an existing report for this repository. If it is still pending, analysis will continue.',
    refreshNotice: 'The report has been queued again for GitHub data fetching and AI analysis.',
    deletedNotice: 'Report deleted.',
    maintenanceRisk: 'Maintenance risk',
    risks: 'Risks',
    learningPath30: '30-day learning path',
    techStackPending: 'Tech stack pending',
    suitableUsersFallback: 'For people looking for practice projects, resume material, and interview prep',
    highlightFallback: 'Automatically organizes project highlights, learning value, and talking points',
    posterPreview: 'Poster preview',
    posterNote: 'The first version shows a screenshot-friendly card. Real image export can be added later.',
    loadHistoryFailed: 'Failed to load report history. Try again later.',
    loadDetailFailed: 'Failed to load report details. Try again later.',
    createFailed: 'Failed to create report. Check the repository URL and try again.',
    incomingRepoInvalid: 'The incoming GitHub repository URL is invalid. Check it and try again.',
    refreshFailed: 'Failed to refresh report. Try again later.',
    deleteConfirm: 'Delete this project report?',
    deleteFailed: 'Failed to delete report. Try again later.',
    checkingLogin: 'Checking login status',
    noReportSummary: 'No report summary yet.',
    loadingDetail: 'Loading report details',
    updatedPrefix: 'Updated: ',
    pollTimeout: 'Analysis is taking longer than usual. Refresh later to view the result.',
    structuredContentMissing: 'The report is completed, but structured content was not loaded. Refresh and try again.',
    noReportContent: 'No report content is available yet.',
  },
  share: {
    indexTitle: 'Public project analysis share page',
    indexDescription: 'After a GitHub project analysis is complete, you can create a public share link from the report.',
    analyzeMine: 'Analyze my GitHub project too',
    loading: 'Loading public project analysis report',
    notFoundTitle: 'Share page not found',
    notFoundMessage: 'This public project analysis report may not be ready yet.',
    eyebrow: 'Project analysis share',
    copyLink: 'Copy share link',
    copiedLink: 'Share link copied',
    projectName: 'Project name',
    githubLink: 'GitHub link',
    generatedAt: 'Generated',
    siteSource: 'Site source',
    techStack: 'Tech stack',
    highlights: 'Project highlights',
    learningValue: 'Learning value',
    resumeAdvice: 'Resume advice',
    interviewAdvice: 'Interview advice',
    optimization: 'Optimization suggestions',
    ctaTitle: 'Analyze another GitHub project',
    ctaButton: 'Analyze GitHub project now',
    emptyContent: 'No clear content extracted yet.',
    emptyAdvice: 'No clear advice extracted yet.',
    emptySummary: 'No project summary extracted yet.',
    scoreSuffix: 'pts',
    inaccessible: 'The public share page is temporarily unavailable',
  },
  pet: {
    assistant: 'AI Pet Assistant',
    name: 'AI Assistant',
    open: 'Open AI Pet Assistant',
    title: 'Drag to reposition. Click to open AI Pet Assistant',
    loginNote: 'Log in to check in, feed, and save your pet style.',
    loginButton: 'Log in to raise your AI pet',
    loading: 'Loading pet status',
    petType: 'Pet type',
    level: 'Level',
    mood: 'Mood',
    food: 'Food',
    exp: 'EXP',    checkinState: "Today's check-in: {{state}}",
    checked: 'Done',
    unchecked: 'Not yet',
    noFoodHint: 'Food is low. Check in tomorrow to get more.',    hungryHint: "I'm hungry. Feed me?",
    dailyTasks: "Today's tasks",
    checkin: 'Daily check-in',
    rewardFood: '+1 food',
    rewardAnalysis: '+2 food',
    analyzeProjectTask: 'Analyze one GitHub project',
    favoriteTask: 'Save one project',
    received: 'Claimed',
    changeSkin: 'Change style',
    feed: 'Feed',
    noFood: 'No food. Check in to get more',
    askAi: 'Ask AI',
    goAnalyze: 'Analyze GitHub project',    drop: "Drop it here. I'll analyze it!",
    catching: 'Project received. Starting analysis!',
    thinking: "I'm reading this project",
    success: 'Report is ready',
    sad: 'Analysis failed. Try again later',
    feeding: 'Full and happy!',
    notChecked: 'You have not checked in today',
    noFoodShort: 'No food left. Check in to get more',
    happy: 'Feeling great today!',    hungry: "I'm a bit hungry",    idle: "Drag a GitHub project to me and I'll take a look.",
    guestStatus: 'Log in to check in, feed, and save your pet style.',
    happyStatus: 'Feeling great. Good time to analyze a project!',
    growthGuideLabel: 'Growth partner',
    growthGuideTitle: 'Hi, I am your growth partner. Let me get to know you first.',
    growthGuideDesc: 'I will learn your major, year, interests, foundation, goals, time budget, and current confusion, then help create a growth profile, recommended direction, learning route, and first-stage tasks.',
    growthGuideMajor: 'Major',
    growthGuideGrade: 'Year',
    growthGuideInterest: 'Interests and foundation',
    growthGuideGoal: 'Direction you want',
    growthGuideTime: 'Weekly time budget',
    growthGuideConfusion: 'Current confusion',
    startGrowthGuide: 'Let me get to know you',
    growthGuideLongTerm: 'Later, you can tell me your direction changed, your goal shifted, or you have less time, and I will help adjust the plan.',
  },
}

export default en
